import i18n from "../../../../shared/localization/i18n";
export enum OperatorType {
    Operator = 1,
    Bot = 2,
    Supervisor = 3,
}

export const operatorTypeToString = (operatorType: OperatorType): string => {
    switch(operatorType) {
        case OperatorType.Operator:
            return i18n.t('common.operator');
        case OperatorType.Bot:
            return i18n.t('common.bot');
        case OperatorType.Supervisor:
            return i18n.t('common.supervisor');
    }
}